let routes = [
  {
    path: '/demande-renouvellement-psychotherapeute',
    component: () => import('../views/DemandeRenouvellementPsychotherapeute.vue'),
    props: true
  },
  {
    path: '/demande-renouvellement-psychotherapeute/:step',
    component: () => import('../views/DemandeRenouvellementPsychotherapeute.vue'),
    props: true
  }
]

export default routes;